import { render, staticRenderFns } from "./ecoShop.vue?vue&type=template&id=53e3ff2f"
import script from "./ecoShop.vue?vue&type=script&lang=js"
export * from "./ecoShop.vue?vue&type=script&lang=js"
import style0 from "./ecoShop.vue?vue&type=style&index=0&id=53e3ff2f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports